(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lum-category-rails"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lum-rail')) {
    class LumRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        this.nav = this.querySelector('[data-rail-nav]');
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        if (!this.track) return;

        this.onScroll = () => this.update();
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
      }

      go(dir) {
        const t = this.track;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const rtl = getComputedStyle(t).direction === 'rtl' ? -1 : 1;
        t.scrollBy({ left: dir * rtl * t.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const x = Math.abs(t.scrollLeft);
        this.nav.hidden = max <= 2;
        this.prev.disabled = x <= 2;
        this.next.disabled = x >= max - 2;
      }
    }
    customElements.define('lum-rail', LumRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lum-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lum-slideshow')) {
    class LumSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-show-track]');
        this.slides = [...this.querySelectorAll('[data-show-slide]')];
        this.dots = [...this.querySelectorAll('[data-show-dot]')];
        this.toggle = this.querySelector('[data-show-toggle]');
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        if (this.slides.length < 2) return;

        this.querySelector('[data-show-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-show-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));
        this.toggle?.addEventListener('click', () => this.setPaused(!this.userPaused, true));

        this.onScroll = () => {
          clearTimeout(this.scrollEnd);
          this.scrollEnd = setTimeout(() => this.sync(), 80);
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        // Otomatik oynatma: hover/odak/gizli sekmede beklet
        this.hold = new Set();
        const holdOn = (k) => () => { this.hold.add(k); this.schedule(); };
        const holdOff = (k) => () => { this.hold.delete(k); this.schedule(); };
        this.addEventListener('pointerenter', holdOn('hover'));
        this.addEventListener('pointerleave', holdOff('hover'));
        // Yalnız klavye odağında beklet; fareyle tıklanan düğme otomatik geçişi kilitlemesin
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) holdOn('focus')(); });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) holdOff('focus')(); });
        this.onVisibility = () => { document.hidden ? this.hold.add('hidden') : this.hold.delete('hidden'); this.schedule(); };
        document.addEventListener('visibilitychange', this.onVisibility);

        this.autoplay = this.hasAttribute('data-autoplay');
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setPaused(!this.autoplay || reduce, false);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i, fromUser) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        this.mark();
        if (fromUser) this.schedule();
      }

      sync() {
        const w = this.track.clientWidth || 1;
        const i = Math.round(this.track.scrollLeft / w);
        if (i !== this.index) { this.index = i; this.mark(); this.schedule(); }
      }

      mark() {
        this.dots.forEach((d, i) => d.toggleAttribute('aria-current', i === this.index));
        this.slides.forEach((s, i) => {
          s.toggleAttribute('inert', i !== this.index);
          s.setAttribute('aria-hidden', String(i !== this.index));
        });
      }

      setPaused(paused, fromUser) {
        this.userPaused = paused;
        if (this.toggle) {
          this.toggle.setAttribute('aria-pressed', String(paused));
          this.toggle.setAttribute('aria-label', paused ? 'Slaytları başlat' : 'Slaytları durdur');
          this.classList.toggle('is-paused', paused);
        }
        if (fromUser && !paused) this.hold.clear();
        this.mark();
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.autoplay || this.userPaused || this.hold.size) return;
        this.timer = setTimeout(() => this.go(this.index + 1, true), this.interval);
      }
    }
    customElements.define('lum-slideshow', LumSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
